import { maybe, nothing } from "tsmonads";
import { isEmpty } from "ramda";
import { isNullOrUndefined } from "util";
export var toInt = function (s) {
    if (isNullOrUndefined(s) || isEmpty(s)) {
        return nothing();
    }
    var i = parseInt(s, 10);
    if (isNaN(i)) {
        return nothing();
    }
    return maybe(i);
};
export var seconds = function (s) { return 1000 * s; };
export var minutes = function (m) { return seconds(60) * m; };
export var hours = function (h) { return minutes(60) * h; };
export var days = function (d) { return hours(24) * d; };
export var weeks = function (w) { return days(7) * w; };



//////////////////
// WEBPACK FOOTER
// ./src/data/utils.ts
// module id = 557
// module chunks = 0